import { httpsCallable } from 'firebase/functions'
import { getBlob, ref } from 'firebase/storage'
import { functions, storage } from '../../../services/firebase.service'
import { NewsImageUpload } from '../types/news.types'

/** Calls a News Cloud Function and returns its typed payload. */
export const readNews = async <T>(name: string, input: object): Promise<T> => (await httpsCallable<object, T>(functions, name)(input)).data

/** Downloads a news image from Firebase Storage as a blob. */
export const loadNewsImage = (path: string) => getBlob(ref(storage, path))

const imageUrls = new Set<string>()

/** Creates and tracks an object URL for a downloaded news image. */
export const newsImageUrl = (blob: Blob) => {
  const url = URL.createObjectURL(blob)
  imageUrls.add(url)
  return url
}

/** Revokes one tracked news image object URL. */
export const revokeNewsImage = (url: string) => {
  URL.revokeObjectURL(url)
  imageUrls.delete(url)
}

/** Revokes and clears every tracked news image object URL. */
export const clearNewsImages = () => {
  imageUrls.forEach((url) => URL.revokeObjectURL(url))
  imageUrls.clear()
}

/** Encodes an image file as the base64 payload expected by the backend. */
export const encodeNewsImage = (file: File): Promise<NewsImageUpload> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = () => reject(new Error('IMAGE_READ_FAILED'))
    reader.onload = () => resolve({ name: file.name, contentType: file.type, base64: String(reader.result).split(',')[1] })
    reader.readAsDataURL(file)
  })
